import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { Drawer as MUIDrawer, Divider, IconButton } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import classNames from "classnames";
import React from "react";
import { styles } from "../styles";
import { Typography, Avatar } from "@material-ui/core";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import withStyles from "@material-ui/core/styles/withStyles";
import ListItem from "@material-ui/core/ListItem";
import AccountCircle from "@material-ui/icons/AccountCircle";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { get } from "lodash";
import Tooltip from "@material-ui/core/Tooltip";
import { fade } from '@material-ui/core/styles/colorManipulator';
import { Home, AccountBox, FolderShared, Security, Work, PowerSettingsNew, ViewList, DirectionsCar, GroupWork, LineWeight, Today, AlarmOn, ExitToApp, Delete, Code, VerifiedUser, SupervisedUserCircle, Build, Assignment, QuestionAnswer, Layers, NotificationImportant, CropFree, People, DateRange, HelpOutline, Business, Chat, Schedule, LocalAirport, TrendingUp, Computer, ImportContacts, PlaylistAddCheck, Description, Warning, School, BusinessCenter, PermDeviceInformation, Note, DeleteSweep, EventNote, AirplanemodeActive, Flare, ContactMail, Timelapse, Message, Lock, Notifications, YouTube, Forum, FileCopy, Storage, ListAlt, List, GetApp, SupervisorAccount, CalendarToday, ChatBubble, EmojiTransportation } from "@material-ui/icons";
import BarChartOutlinedIcon from "@material-ui/icons/BarChartOutlined";
import { Link } from "react-router-dom";
var icons = {
  Home: Home,
  AccountBox: AccountBox,
  FolderShared: FolderShared,
  Security: Security,
  Work: Work,
  PowerSettingsNew: PowerSettingsNew,
  ViewList: ViewList,
  DirectionsCar: DirectionsCar,
  GroupWork: GroupWork,
  LineWeight: LineWeight,
  Today: Today,
  AlarmOn: AlarmOn,
  Delete: Delete,
  Code: Code,
  VerifiedUser: VerifiedUser,
  SupervisedUserCircle: SupervisedUserCircle,
  Build: Build,
  Assignment: Assignment,
  QuestionAnswer: QuestionAnswer,
  Layers: Layers,
  NotificationImportant: NotificationImportant,
  CropFree: CropFree,
  People: People,
  DateRange: DateRange,
  HelpOutline: HelpOutline,
  Business: Business,
  Chat: Chat,
  Schedule: Schedule,
  LocalAirport: LocalAirport,
  TrendingUp: TrendingUp,
  Computer: Computer,
  ImportContacts: ImportContacts,
  PlaylistAddCheck: PlaylistAddCheck,
  Description: Description,
  Warning: Warning,
  School: School,
  ExitToApp: ExitToApp,
  BusinessCenter: BusinessCenter,
  PermDeviceInformation: PermDeviceInformation,
  Note: Note,
  BarChartOutlinedIcon: BarChartOutlinedIcon,
  GetApp: GetApp,
  EventNote: EventNote,
  DeleteSweep: DeleteSweep,
  AirplanemodeActive: AirplanemodeActive,
  Flare: Flare,
  ContactMail: ContactMail,
  Timelapse: Timelapse,
  Message: Message,
  Lock: Lock,
  Notifications: Notifications,
  YouTube: YouTube,
  Forum: Forum,
  FileCopy: FileCopy,
  Storage: Storage,
  ListAlt: ListAlt,
  List: List,
  SupervisorAccount: SupervisorAccount,
  CalendarToday: CalendarToday,
  ChatBubble: ChatBubble,
  EmojiTransportation: EmojiTransportation
};
var ListItemStyled = withStyles(function () {
  return {
    root: {
      paddingTop: 6,
      paddingBottom: 6,
      border: 0,
      "&$custom": {
        backgroundColor: "#eee",
        borderBottom: "onset 4px solid #0188cc"
      },
      "&$selected": {
        backgroundColor: fade('#0188cc', 0.2),
        color: "#0188cc"
      },
      "&$selected:hover": {
        backgroundColor: fade('#0188cc', 0.2),
        color: "#0188cc"
      },
      "&:hover": {
        backgroundColor: fade('#D8D8D8', 0.4),
        color: "black"
      }
    },
    child: {},
    selected: {}
  };
})(ListItem);
var ListItemStyledJM = withStyles(function () {
  return {
    root: {
      paddingTop: 6,
      paddingBottom: 6,
      border: 0,
      "&$custom": {
        backgroundColor: "#eee",
        borderBottom: "onset 4px solid #0188cc"
      },
      "&$selected": {
        backgroundColor: fade('#0188cc', 0.2),
        color: "#0188cc"
      },
      "&$selected:hover": {
        backgroundColor: fade('#0188cc', 0.2),
        color: "#0188cc"
      },
      "&:hover": {
        backgroundColor: fade('#D8D8D8', 0.4),
        color: "black"
      }
    },
    selected: {}
  };
})(ListItem);
var ListItemStyledRM = withStyles(function () {
  return {
    root: {
      paddingTop: 6,
      paddingBottom: 6,
      border: 0,
      "&$custom": {
        backgroundColor: "#eee",
        borderBottom: "onset 4px solid #0188cc"
      },
      "&$selected": {
        backgroundColor: fade('#0188cc', 0.2),
        color: "#0188cc"
      },
      "&$selected:hover": {
        backgroundColor: fade('#0188cc', 0.2),
        color: "#0188cc"
      },
      "&:hover": {
        backgroundColor: fade('#D8D8D8', 0.4),
        color: "black"
      }
    },
    selected: {}
  };
})(ListItem);
var ListItemStyledUM = withStyles(function () {
  return {
    root: {
      paddingTop: 6,
      paddingBottom: 6,
      border: 0,
      "&$custom": {
        backgroundColor: "#eee",
        borderBottom: "onset 4px solid #0188cc"
      },
      "&$selected": {
        backgroundColor: fade('#0188cc', 0.2),
        color: "#0188cc"
      },
      "&$selected:hover": {
        backgroundColor: fade('#0188cc', 0.2),
        color: "#0188cc"
      },
      "&:hover": {
        backgroundColor: fade('#D8D8D8', 0.4),
        color: "black"
      }
    },
    selected: {}
  };
})(ListItem);
var ListItemStyledREM = withStyles(function () {
  return {
    root: {
      paddingTop: 6,
      paddingBottom: 6,
      border: 0,
      "&$custom": {
        backgroundColor: "#eee",
        borderBottom: "onset 4px solid #0188cc"
      },
      "&$selected": {
        backgroundColor: fade('#0188cc', 0.2),
        color: "#0188cc"
      },
      "&$selected:hover": {
        backgroundColor: fade('#0188cc', 0.2),
        color: "#0188cc"
      },
      "&:hover": {
        backgroundColor: fade('#D8D8D8', 0.4),
        color: "black"
      }
    },
    selected: {}
  };
})(ListItem);
var ListItemStyledSU = withStyles(function () {
  return {
    root: {
      paddingTop: 6,
      paddingBottom: 6,
      border: 0,
      "&$custom": {
        backgroundColor: "#eee",
        borderBottom: "onset 4px solid #0188cc"
      },
      "&$selected": {
        backgroundColor: fade('#0188cc', 0.2),
        color: "#0188cc"
      },
      "&$selected:hover": {
        backgroundColor: fade('#0188cc', 0.2),
        color: "#0188cc"
      },
      "&:hover": {
        backgroundColor: fade('#D8D8D8', 0.4),
        color: "black"
      }
    },
    selected: {}
  };
})(ListItem);
var ListItemStyledPT = withStyles(function () {
  return {
    root: {
      paddingTop: 6,
      paddingBottom: 6,
      border: 0,
      "&$custom": {
        backgroundColor: "#eee",
        borderBottom: "onset 4px solid #0188cc"
      },
      "&$selected": {
        backgroundColor: fade('#0188cc', 0.2),
        color: "#0188cc"
      },
      "&$selected:hover": {
        backgroundColor: fade('#0188cc', 0.2),
        color: "#0188cc"
      },
      "&:hover": {
        backgroundColor: fade('#D8D8D8', 0.4),
        color: "black"
      }
    },
    selected: {}
  };
})(ListItem);
var defaultHeader = {
  color: 'black',
  backgroundColor: 'white',
  border: "none",
  boxShadow: "none",
  paddingTop: 1,
  paddingBottom: 1
};
var selectedHeader = {
  color: '#0188cc',
  backgroundColor: 'white',
  border: "none",
  boxShadow: "none",
  paddingTop: 1,
  paddingBottom: 1
};
var hoverHeader = {
  backgroundColor: fade('#D8D8D8', 0.4),
  color: "black",
  border: "none",
  boxShadow: "none",
  paddingTop: 1,
  paddingBottom: 1
};
var defaultIcon = {
  marginRight: 24,
  color: 'grey'
};
var selectedIcon = {
  marginRight: 24,
  color: '#0188cc'
};
var hoverIcon = {
  marginRight: 24,
  color: 'grey'
}; //Header Style

var listJMHeaderStyle = defaultHeader;
var listRMHeaderStyle = defaultHeader;
var listUMHeaderStyle = defaultHeader;
var listREMHeaderStyle = defaultHeader;
var listSUHeaderStyle = defaultHeader;
var listPTHeaderStyle = defaultHeader; //Icon Style

var listJMIconStyle = defaultIcon;
var listRMIconStyle = defaultIcon;
var listUMIconStyle = defaultIcon;
var listREMIconStyle = defaultIcon;
var listSUIconStyle = defaultIcon;
var listPTIconStyle = defaultIcon;

var Drawer = /*#__PURE__*/function (_React$Component) {
  _inherits(Drawer, _React$Component);

  var _super = _createSuper(Drawer);

  function Drawer(props) {
    var _this;

    _classCallCheck(this, Drawer);

    _this = _super.call(this, props);
    _this.state = {};

    _this.handleListItemClickPage = function (e) {
      _this.setState({
        selectedIndexJM: false
      });

      _this.setState({
        selectedIndexRM: false
      });

      _this.setState({
        selectedIndexUM: false
      });

      _this.setState({
        selectedIndexREM: false
      });

      _this.setState({
        selectedIndexSU: false
      });

      _this.setState({
        selectedIndexPT: false
      });

      _this.setState({
        selectedIndex: e
      });
    };

    _this.handleListItemClickJMGoup = function (e) {
      _this.setState({
        selectedIndex: false
      });

      _this.setState({
        selectedIndexRM: false
      });

      _this.setState({
        selectedIndexUM: false
      });

      _this.setState({
        selectedIndexREM: false
      });

      _this.setState({
        selectedIndexSU: false
      });

      _this.setState({
        selectedIndexPT: false
      });

      _this.setState({
        selectedIndexJM: e
      });
    };

    _this.handleListItemClickRMGoup = function (e) {
      _this.setState({
        selectedIndex: false
      });

      _this.setState({
        selectedIndexJM: false
      });

      _this.setState({
        selectedIndexUM: false
      });

      _this.setState({
        selectedIndexREM: false
      });

      _this.setState({
        selectedIndexSU: false
      });

      _this.setState({
        selectedIndexPT: false
      });

      _this.setState({
        selectedIndexRM: e
      });
    };

    _this.handleListItemClickUMGoup = function (e) {
      _this.setState({
        selectedIndex: false
      });

      _this.setState({
        selectedIndexJM: false
      });

      _this.setState({
        selectedIndexRM: false
      });

      _this.setState({
        selectedIndexREM: false
      });

      _this.setState({
        selectedIndexSU: false
      });

      _this.setState({
        selectedIndexPT: false
      });

      _this.setState({
        selectedIndexUM: e
      });
    };

    _this.handleListItemClickREMGoup = function (e) {
      _this.setState({
        selectedIndex: false
      });

      _this.setState({
        selectedIndexJM: false
      });

      _this.setState({
        selectedIndexRM: false
      });

      _this.setState({
        selectedIndexUM: false
      });

      _this.setState({
        selectedIndexSU: false
      });

      _this.setState({
        selectedIndexPT: false
      });

      _this.setState({
        selectedIndexREM: e
      });
    };

    _this.handleListItemClickSUGoup = function (e) {
      _this.setState({
        selectedIndex: false
      });

      _this.setState({
        selectedIndexJM: false
      });

      _this.setState({
        selectedIndexRM: false
      });

      _this.setState({
        selectedIndexREM: false
      });

      _this.setState({
        selectedIndexUM: false
      });

      _this.setState({
        selectedIndexPT: false
      });

      _this.setState({
        selectedIndexSU: e
      });
    };

    _this.handleListItemClickPTGoup = function (e) {
      _this.setState({
        selectedIndex: false
      });

      _this.setState({
        selectedIndexJM: false
      });

      _this.setState({
        selectedIndexRM: false
      });

      _this.setState({
        selectedIndexUM: false
      });

      _this.setState({
        selectedIndexREM: false
      });

      _this.setState({
        selectedIndexSU: false
      });

      _this.setState({
        selectedIndexPT: e
      });
    };

    _this.mouseHover = function (e) {
      _this.setState({
        mouseHoverPage: e
      });
    };

    _this.mouseOut = function (e) {
      _this.setState({
        mouseHoverPage: false
      });
    };

    _this.toggleHover = function (e) {
      _this.setState({
        mouseHover: e
      });
    };

    _this.toggleExpandJM = function () {
      _this.setState({
        JMExpand: !_this.state.JMExpand
      });
    };

    _this.toggleExpandRM = function () {
      _this.setState({
        RMExpand: !_this.state.RMExpand
      });
    };

    _this.toggleExpandUM = function () {
      _this.setState({
        UMExpand: !_this.state.UMExpand
      });
    };

    _this.toggleExpandREM = function () {
      _this.setState({
        REMExpand: !_this.state.REMExpand
      });
    };

    _this.toggleExpandSU = function () {
      _this.setState({
        SUExpand: !_this.state.SUExpand
      });
    };

    _this.toggleExpandPT = function () {
      _this.setState({
        PTExpand: !_this.state.PTExpand
      });
    };

    _this.getLinks = function () {
      var open = _this.props.open; //Default Hover

      if (_this.state.mouseHover === "NA") {
        _this.setDefault();
      } //Job Management Styles


      if (_this.state.selectedIndexJM) {
        _this.setDefault();

        listJMHeaderStyle = selectedHeader;
        listJMIconStyle = selectedIcon;
      } else if (_this.state.mouseHover === 'job') {
        _this.setDefault();

        if (!_this.state.JMExpand) {
          listJMHeaderStyle = hoverHeader;
          listJMIconStyle = hoverIcon;
        }
      } //Report Management Styles


      if (_this.state.selectedIndexRM) {
        _this.setDefault();

        listRMHeaderStyle = selectedHeader;
        listRMIconStyle = selectedIcon;
      } else if (_this.state.mouseHover === 'report') {
        _this.setDefault();

        if (!_this.state.RMExpand) {
          listRMHeaderStyle = hoverHeader;
          listRMIconStyle = hoverIcon;
        }
      } //User Management Styles


      if (_this.state.selectedIndexUM) {
        _this.setDefault();

        listUMHeaderStyle = selectedHeader;
        listUMIconStyle = selectedIcon;
      } else if (_this.state.mouseHover === 'user') {
        _this.setDefault();

        if (!_this.state.UMExpand) {
          listUMHeaderStyle = hoverHeader;
          listUMIconStyle = hoverIcon;
        }
      } //Resource Management Styles


      if (_this.state.selectedIndexREM) {
        _this.setDefault();

        listREMHeaderStyle = selectedHeader;
        listREMIconStyle = selectedIcon;
      } else if (_this.state.mouseHover === 'resource') {
        _this.setDefault();

        if (!_this.state.REMExpand) {
          listREMHeaderStyle = hoverHeader;
          listREMIconStyle = hoverIcon;
        }
      } //Support Management Styles


      if (_this.state.selectedIndexSU) {
        _this.setDefault();

        listSUHeaderStyle = selectedHeader;
        listSUIconStyle = selectedIcon;
      } else if (_this.state.mouseHover === 'support') {
        _this.setDefault();

        if (!_this.state.REMExpand) {
          listSUHeaderStyle = hoverHeader;
          listSUIconStyle = hoverIcon;
        }
      } //Prowork Tools  Styles


      if (_this.state.selectedIndexPT) {
        _this.setDefault();

        listPTHeaderStyle = selectedHeader;
        listPTIconStyle = selectedIcon;
      } else if (_this.state.mouseHover === 'tools') {
        _this.setDefault();

        if (!_this.state.REMExpand) {
          listPTHeaderStyle = hoverHeader;
          listPTIconStyle = hoverIcon;
        }
      }

      return _this.props.menuItems !== false && _this.props.menuItems.map(function (e, i) {
        switch (e.type) {
          case "page":
            {
              var Icon;

              if (typeof e.icon === "string" || e.icon instanceof String) {
                Icon = icons[e.icon];
              } else {
                Icon = e.icon;
              }

              return /*#__PURE__*/React.createElement(Tooltip, {
                title: e.label,
                enterDelay: 500,
                disableHoverListener: _this.props.open,
                disableFocusListener: _this.props.open,
                disableTouchListener: _this.props.open,
                key: i
              }, /*#__PURE__*/React.createElement(ListItemStyled, {
                custom: true,
                button: true,
                component: Link,
                to: e.link,
                selected: _this.state.selectedIndex === 'Page' + (i + 1),
                onClick: function onClick(event) {
                  return _this.handleListItemClickPage('Page' + (i + 1));
                },
                onMouseEnter: function onMouseEnter(event) {
                  return _this.mouseHover('Page' + (i + 1));
                },
                onMouseLeave: function onMouseLeave(event) {
                  return _this.mouseOut('Page' + (i + 1));
                }
              }, /*#__PURE__*/React.createElement(ListItemIcon, null, 'Page' + (i + 1) === _this.state.selectedIndex ? /*#__PURE__*/React.createElement(Icon, {
                style: {
                  color: "#0188cc"
                }
              }) : 'Page' + (i + 1) === _this.state.mouseHoverPage ? /*#__PURE__*/React.createElement(Icon, {
                style: {
                  color: "grey"
                }
              }) : /*#__PURE__*/React.createElement(Icon, {
                style: {
                  color: "grey"
                }
              })), /*#__PURE__*/React.createElement(ListItemText, null, e.label)));
            }

          case "JM":
            {
              var _Icon = icons[e.icon];
              return /*#__PURE__*/React.createElement(ExpansionPanel, {
                key: i,
                style: {
                  border: "none",
                  boxShadow: "none"
                }
              }, /*#__PURE__*/React.createElement(ExpansionPanelSummary, {
                expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
                style: listJMHeaderStyle,
                onMouseEnter: function onMouseEnter(event) {
                  return _this.toggleHover('job');
                },
                onMouseLeave: function onMouseLeave(event) {
                  return _this.toggleHover('NA');
                },
                onClick: function onClick(event) {
                  return _this.toggleExpandJM();
                }
              }, /*#__PURE__*/React.createElement(Tooltip, {
                title: e.label,
                enterDelay: 500,
                disableHoverListener: _this.props.open,
                disableFocusListener: _this.props.open,
                disableTouchListener: _this.props.open,
                key: i
              }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(_Icon, {
                style: listJMIconStyle
              }), open && e.label))), /*#__PURE__*/React.createElement(ExpansionPanelDetails, {
                style: {
                  display: "block",
                  padding: 0,
                  border: "none",
                  boxShadow: "none"
                }
              }, e.sub_pages.map(function (f, a) {
                var Ico = icons[f.icon];
                return /*#__PURE__*/React.createElement(Tooltip, {
                  title: f.label,
                  enterDelay: 500,
                  disableHoverListener: _this.props.open,
                  disableFocusListener: _this.props.open,
                  disableTouchListener: _this.props.open,
                  key: a
                }, /*#__PURE__*/React.createElement(ListItemStyledJM, {
                  button: true,
                  component: Link,
                  to: f.link,
                  selected: _this.state.selectedIndexJM === a + 1,
                  onClick: function onClick(event) {
                    return _this.handleListItemClickJMGoup(a + 1);
                  },
                  onMouseEnter: function onMouseEnter(event) {
                    return _this.mouseHover('JM' + (a + 1));
                  },
                  onMouseLeave: function onMouseLeave(event) {
                    return _this.mouseOut('JM' + (a + 1));
                  }
                }, /*#__PURE__*/React.createElement(ListItemIcon, null, a + 1 === _this.state.selectedIndexJM ? /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "#0188cc"
                  }
                }) : 'JM' + (a + 1) === _this.state.mouseHoverPage ? /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "grey"
                  }
                }) : /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "grey"
                  }
                })), /*#__PURE__*/React.createElement(ListItemText, null, f.label)));
              })));
            }

          case "RM":
            {
              var _Icon2 = icons[e.icon];
              return /*#__PURE__*/React.createElement(ExpansionPanel, {
                key: i,
                style: {
                  border: "none",
                  boxShadow: "none"
                }
              }, /*#__PURE__*/React.createElement(ExpansionPanelSummary, {
                expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
                style: listRMHeaderStyle,
                onMouseEnter: function onMouseEnter(event) {
                  return _this.toggleHover('report');
                },
                onMouseLeave: function onMouseLeave(event) {
                  return _this.toggleHover('NA');
                },
                onClick: function onClick(event) {
                  return _this.toggleExpandRM();
                }
              }, /*#__PURE__*/React.createElement(Tooltip, {
                title: e.label,
                enterDelay: 500,
                disableHoverListener: _this.props.open,
                disableFocusListener: _this.props.open,
                disableTouchListener: _this.props.open,
                key: i
              }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(_Icon2, {
                style: listRMIconStyle
              }), open && e.label))), /*#__PURE__*/React.createElement(ExpansionPanelDetails, {
                style: {
                  display: "block",
                  padding: 0,
                  border: "none",
                  boxShadow: "none"
                }
              }, e.sub_pages.map(function (f, a) {
                var Ico = icons[f.icon];
                return /*#__PURE__*/React.createElement(Tooltip, {
                  title: f.label,
                  enterDelay: 500,
                  disableHoverListener: _this.props.open,
                  disableFocusListener: _this.props.open,
                  disableTouchListener: _this.props.open,
                  key: a
                }, /*#__PURE__*/React.createElement(ListItemStyledRM, {
                  button: true,
                  component: Link,
                  to: f.link,
                  selected: _this.state.selectedIndexRM === a + 1,
                  onClick: function onClick(event) {
                    return _this.handleListItemClickRMGoup(a + 1);
                  },
                  onMouseEnter: function onMouseEnter(event) {
                    return _this.mouseHover('RM' + (a + 1));
                  },
                  onMouseLeave: function onMouseLeave(event) {
                    return _this.mouseOut('RM' + (a + 1));
                  }
                }, /*#__PURE__*/React.createElement(ListItemIcon, null, a + 1 === _this.state.selectedIndexRM ? /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "#0188cc"
                  }
                }) : 'RM' + (a + 1) === _this.state.mouseHoverPage ? /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "grey"
                  }
                }) : /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "grey"
                  }
                })), /*#__PURE__*/React.createElement(ListItemText, null, f.label)));
              })));
            }

          case "UM":
            {
              var _Icon3 = icons[e.icon];
              return /*#__PURE__*/React.createElement(ExpansionPanel, {
                key: i,
                style: {
                  border: "none",
                  boxShadow: "none"
                }
              }, /*#__PURE__*/React.createElement(ExpansionPanelSummary, {
                expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
                style: listUMHeaderStyle,
                onMouseEnter: function onMouseEnter(event) {
                  return _this.toggleHover('user');
                },
                onMouseLeave: function onMouseLeave(event) {
                  return _this.toggleHover('NA');
                },
                onClick: function onClick(event) {
                  return _this.toggleExpandUM();
                }
              }, /*#__PURE__*/React.createElement(Tooltip, {
                title: e.label,
                enterDelay: 500,
                disableHoverListener: _this.props.open,
                disableFocusListener: _this.props.open,
                disableTouchListener: _this.props.open,
                key: i
              }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(_Icon3, {
                style: listUMIconStyle
              }), open && e.label))), /*#__PURE__*/React.createElement(ExpansionPanelDetails, {
                style: {
                  display: "block",
                  padding: 0,
                  border: "none",
                  boxShadow: "none"
                }
              }, e.sub_pages.map(function (f, a) {
                var Ico = icons[f.icon];
                return /*#__PURE__*/React.createElement(Tooltip, {
                  title: f.label,
                  enterDelay: 500,
                  disableHoverListener: _this.props.open,
                  disableFocusListener: _this.props.open,
                  disableTouchListener: _this.props.open,
                  key: a
                }, /*#__PURE__*/React.createElement(ListItemStyledUM, {
                  button: true,
                  component: Link,
                  to: f.link,
                  selected: _this.state.selectedIndexUM === a + 1,
                  onClick: function onClick(event) {
                    return _this.handleListItemClickUMGoup(a + 1);
                  },
                  onMouseEnter: function onMouseEnter(event) {
                    return _this.mouseHover('UM' + (a + 1));
                  },
                  onMouseLeave: function onMouseLeave(event) {
                    return _this.mouseOut('UM' + (a + 1));
                  }
                }, /*#__PURE__*/React.createElement(ListItemIcon, null, a + 1 === _this.state.selectedIndexUM ? /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "#0188cc"
                  }
                }) : 'UM' + (a + 1) === _this.state.mouseHoverPage ? /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "grey"
                  }
                }) : /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "grey"
                  }
                })), /*#__PURE__*/React.createElement(ListItemText, null, f.label)));
              })));
            }

          case "REM":
            {
              var _Icon4 = icons[e.icon];
              return /*#__PURE__*/React.createElement(ExpansionPanel, {
                key: i,
                style: {
                  border: "none",
                  boxShadow: "none"
                }
              }, /*#__PURE__*/React.createElement(ExpansionPanelSummary, {
                expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
                style: listREMHeaderStyle,
                onMouseEnter: function onMouseEnter(event) {
                  return _this.toggleHover('resource');
                },
                onMouseLeave: function onMouseLeave(event) {
                  return _this.toggleHover('NA');
                },
                onClick: function onClick(event) {
                  return _this.toggleExpandREM();
                }
              }, /*#__PURE__*/React.createElement(Tooltip, {
                title: e.label,
                enterDelay: 500,
                disableHoverListener: _this.props.open,
                disableFocusListener: _this.props.open,
                disableTouchListener: _this.props.open,
                key: i
              }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(_Icon4, {
                style: listREMIconStyle
              }), open && e.label))), /*#__PURE__*/React.createElement(ExpansionPanelDetails, {
                style: {
                  display: "block",
                  padding: 0,
                  border: "none",
                  boxShadow: "none"
                }
              }, e.sub_pages.map(function (f, a) {
                var Ico = icons[f.icon];
                return /*#__PURE__*/React.createElement(Tooltip, {
                  title: f.label,
                  enterDelay: 500,
                  disableHoverListener: _this.props.open,
                  disableFocusListener: _this.props.open,
                  disableTouchListener: _this.props.open,
                  key: a
                }, /*#__PURE__*/React.createElement(ListItemStyledREM, {
                  button: true,
                  component: Link,
                  to: f.link,
                  selected: _this.state.selectedIndexREM === a + 1,
                  onClick: function onClick(event) {
                    return _this.handleListItemClickREMGoup(a + 1);
                  },
                  onMouseEnter: function onMouseEnter(event) {
                    return _this.mouseHover('REM' + (a + 1));
                  },
                  onMouseLeave: function onMouseLeave(event) {
                    return _this.mouseOut('REM' + (a + 1));
                  }
                }, /*#__PURE__*/React.createElement(ListItemIcon, null, a + 1 === _this.state.selectedIndexREM ? /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "#0188cc"
                  }
                }) : 'REM' + (a + 1) === _this.state.mouseHoverPage ? /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "grey"
                  }
                }) : /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "grey"
                  }
                })), /*#__PURE__*/React.createElement(ListItemText, null, f.label)));
              })));
            }

          case "SU":
            {
              var _Icon5 = icons[e.icon];
              return /*#__PURE__*/React.createElement(ExpansionPanel, {
                key: i,
                style: {
                  border: "none",
                  boxShadow: "none"
                }
              }, /*#__PURE__*/React.createElement(ExpansionPanelSummary, {
                expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
                style: listSUHeaderStyle,
                onMouseEnter: function onMouseEnter(event) {
                  return _this.toggleHover('support');
                },
                onMouseLeave: function onMouseLeave(event) {
                  return _this.toggleHover('NA');
                },
                onClick: function onClick(event) {
                  return _this.toggleExpandSU();
                }
              }, /*#__PURE__*/React.createElement(Tooltip, {
                title: e.label,
                enterDelay: 500,
                disableHoverListener: _this.props.open,
                disableFocusListener: _this.props.open,
                disableTouchListener: _this.props.open,
                key: i
              }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(_Icon5, {
                style: listSUIconStyle
              }), open && e.label))), /*#__PURE__*/React.createElement(ExpansionPanelDetails, {
                style: {
                  display: "block",
                  padding: 0,
                  border: "none",
                  boxShadow: "none"
                }
              }, e.sub_pages.map(function (f, a) {
                var Ico = icons[f.icon];
                return /*#__PURE__*/React.createElement(Tooltip, {
                  title: f.label,
                  enterDelay: 500,
                  disableHoverListener: _this.props.open,
                  disableFocusListener: _this.props.open,
                  disableTouchListener: _this.props.open,
                  key: a
                }, /*#__PURE__*/React.createElement(ListItemStyledSU, {
                  button: true,
                  component: Link,
                  to: f.link,
                  selected: _this.state.selectedIndexSU === a + 1,
                  onClick: function onClick(event) {
                    return _this.handleListItemClickSUGoup(a + 1);
                  },
                  onMouseEnter: function onMouseEnter(event) {
                    return _this.mouseHover('SU' + (a + 1));
                  },
                  onMouseLeave: function onMouseLeave(event) {
                    return _this.mouseOut('SU' + (a + 1));
                  }
                }, /*#__PURE__*/React.createElement(ListItemIcon, null, a + 1 === _this.state.selectedIndexSU ? /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "#0188cc"
                  }
                }) : 'SU' + (a + 1) === _this.state.mouseHoverPage ? /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "grey"
                  }
                }) : /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "grey"
                  }
                })), /*#__PURE__*/React.createElement(ListItemText, null, f.label)));
              })));
            }

          case "PT":
            {
              var _Icon6 = icons[e.icon];
              return /*#__PURE__*/React.createElement(ExpansionPanel, {
                key: i,
                style: {
                  border: "none",
                  boxShadow: "none"
                }
              }, /*#__PURE__*/React.createElement(ExpansionPanelSummary, {
                expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
                style: listPTHeaderStyle,
                onMouseEnter: function onMouseEnter(event) {
                  return _this.toggleHover('tools');
                },
                onMouseLeave: function onMouseLeave(event) {
                  return _this.toggleHover('NA');
                },
                onClick: function onClick(event) {
                  return _this.toggleExpandPT();
                }
              }, /*#__PURE__*/React.createElement(Tooltip, {
                title: e.label,
                enterDelay: 500,
                disableHoverListener: _this.props.open,
                disableFocusListener: _this.props.open,
                disableTouchListener: _this.props.open,
                key: i
              }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(_Icon6, {
                style: listPTIconStyle
              }), open && e.label))), /*#__PURE__*/React.createElement(ExpansionPanelDetails, {
                style: {
                  display: "block",
                  padding: 0,
                  border: "none",
                  boxShadow: "none"
                }
              }, e.sub_pages.map(function (f, a) {
                var Ico = icons[f.icon];
                return /*#__PURE__*/React.createElement(Tooltip, {
                  title: f.label,
                  enterDelay: 500,
                  disableHoverListener: _this.props.open,
                  disableFocusListener: _this.props.open,
                  disableTouchListener: _this.props.open,
                  key: a
                }, /*#__PURE__*/React.createElement(ListItemStyledPT, {
                  button: true,
                  component: Link,
                  to: f.link,
                  selected: _this.state.selectedIndexPT === a + 1,
                  onClick: function onClick(event) {
                    return _this.handleListItemClickPTGoup(a + 1);
                  },
                  onMouseEnter: function onMouseEnter(event) {
                    return _this.mouseHover('PT' + (a + 1));
                  },
                  onMouseLeave: function onMouseLeave(event) {
                    return _this.mouseOut('PT' + (a + 1));
                  }
                }, /*#__PURE__*/React.createElement(ListItemIcon, null, a + 1 === _this.state.selectedIndexPT ? /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "#0188cc"
                  }
                }) : 'PT' + (a + 1) === _this.state.mouseHoverPage ? /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "grey"
                  }
                }) : /*#__PURE__*/React.createElement(Ico, {
                  style: {
                    color: "grey"
                  }
                })), /*#__PURE__*/React.createElement(ListItemText, null, f.label)));
              })));
            }

          case "divider":
            {
              return /*#__PURE__*/React.createElement(Divider, {
                key: i
              });
            }

          default:
            {
              return null;
            }
        }
      });
    };

    _this.state = {
      mouseHover: false,
      mouseHoverPage: false,
      mouseHoverGroup: false,
      selectedIndex: false,
      selectedIndexJM: false,
      selectedIndexRM: false,
      selectedIndexUM: false,
      selectedIndexREM: false,
      selectedIndexSU: false,
      selectedIndexPT: false,
      JMExpand: false,
      RMExpand: false,
      UMExpand: false,
      REMExpand: false,
      SUExpand: false,
      PTExpand: false
    };
    return _this;
  }

  _createClass(Drawer, [{
    key: "setDefault",
    value: function setDefault() {
      //Job Management
      if (this.state.JMExpand) {
        listJMHeaderStyle = selectedHeader;
        listJMIconStyle = selectedIcon;
      } else {
        listJMHeaderStyle = defaultHeader;
        listJMIconStyle = defaultIcon;
      } //Report Management


      if (this.state.RMExpand) {
        listRMHeaderStyle = selectedHeader;
        listRMIconStyle = selectedIcon;
      } else {
        listRMHeaderStyle = defaultHeader;
        listRMIconStyle = defaultIcon;
      } //User Management


      if (this.state.UMExpand) {
        listUMHeaderStyle = selectedHeader;
        listUMIconStyle = selectedIcon;
      } else {
        listUMHeaderStyle = defaultHeader;
        listUMIconStyle = defaultIcon;
      } //Resource Management


      if (this.state.REMExpand) {
        listREMHeaderStyle = selectedHeader;
        listREMIconStyle = selectedIcon;
      } else {
        listREMHeaderStyle = defaultHeader;
        listREMIconStyle = defaultIcon;
      } //Support  Management


      if (this.state.SUExpand) {
        listSUHeaderStyle = selectedHeader;
        listSUIconStyle = selectedIcon;
      } else {
        listSUHeaderStyle = defaultHeader;
        listSUIconStyle = defaultIcon;
      } //Prowork Tools Management


      if (this.state.PTExpand) {
        listPTHeaderStyle = selectedHeader;
        listPTIconStyle = selectedIcon;
      } else {
        listPTHeaderStyle = defaultHeader;
        listPTIconStyle = defaultIcon;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      };
      var date = get(process.env, "REACT_APP_DATE") || null;
      var bg = require("./profilebg.png") || "";
      var profileIm = require("./imgProfile.png") || "";
      var _this$props = this.props,
          profile = _this$props.profile,
          classes = _this$props.classes,
          open = _this$props.open;
      return /*#__PURE__*/React.createElement(MUIDrawer, {
        variant: "permanent",
        classes: {
          paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose)
        },
        open: open
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.toolbar
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: this.props.handleDrawerClose,
        style: {
          float: "left"
        }
      }, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
        style: {
          color: "white"
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: classes.profileDetails,
        style: {
          background: "url(".concat(bg, ")"),
          padding: 12,
          minWidth: "100%",
          backgroundPosition: "50% 0",
          backgroundSize: "cover",
          boxShadow: "inset 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)"
        }
      }, /*#__PURE__*/React.createElement(Avatar, {
        alt: "Profile",
        style: {
          width: this.props.open ? 60 : 40,
          height: this.props.open ? 60 : 40,
          border: "2px solid white",
          cursor: "pointer",
          background: "white"
        },
        component: Link,
        to: "/profile",
        src: profile.profile_image_url !== "" ? profile.profile_image_url : profileIm,
        className: classes.avatar,
        onError: function onError(ev) {
          ev.target.src = profileIm;
        }
      }, profile.profile_image_url === "" ? AccountCircle : ""), this.props.open && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "h5",
        style: {
          color: "white"
        }
      }, profile.first_name + " " + profile.last_name), /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle2",
        style: {
          color: "white"
        }
      }, profile.email))), /*#__PURE__*/React.createElement(Typography, {
        variant: "button",
        style: {
          background: "#eee",
          color: "black",
          width: "100%",
          margin: 0,
          padding: 4,
          paddingLeft: 12
        }
      }, /*#__PURE__*/React.createElement("b", null, this.props.open ? "MAIN NAVIGATION" : "NAV")), this.getLinks(), /*#__PURE__*/React.createElement(ListItemStyled, {
        onClick: function onClick() {
          _this2.props.logout();
        },
        role: undefined,
        button: true
      }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(ExitToApp, null)), /*#__PURE__*/React.createElement(ListItemText, null, "Logout")), /*#__PURE__*/React.createElement("div", {
        style: {
          color: "rgba(0, 0, 0, 0.5)",
          fontSize: "12px",
          padding: "20px"
        }
      }, "Built:", " ", date !== null && new Date(date).toLocaleDateString("en-GB", options)));
    }
  }]);

  return Drawer;
}(React.Component);

export default withStyles(styles)(Drawer);